import * as React from "react";
import FormikAutocompleteField from "../../formik/FormikAutocomplete";
import PropTypes from "prop-types";
import { HttpClientConfig } from "../../../utils/HttpClient";

export const OrganizationCategoryAutocomplete = (props) => {
  const lookupUrl = `${HttpClientConfig.baseURL}/OrganizationCategory/Lookup`;
  const lookupByIdUrl = `${HttpClientConfig.baseURL}/OrganizationCategory/LookupById`;

  const handleAddClick = (e) => {
    console.log(e);
  }

  return (
    <FormikAutocompleteField {...props} lookupUrl={lookupUrl} lookupByIdUrl={lookupByIdUrl} onAddButtonClick={handleAddClick} />
  );
};

OrganizationCategoryAutocomplete.propTypes = {
  fieldName: PropTypes.string,
  label: PropTypes.string,
  formik: PropTypes.any
}

export default OrganizationCategoryAutocomplete;
